import React, { useEffect, useState } from "react";
import Buttonc from "../../common/button";
import styles from "../place-offer/place-offer.module.scss";
import NumberInput from "../../common/numberInput";
import { useInvestorList } from "../../../hooks/react-query/properties/useInvestorList";
import { usePlaceBid } from "../../../hooks/react-query/properties/usePlaceBid";
import { useToast } from "../../common/toast/toast";
import { Sidebar } from "primereact/sidebar";
import ViewPreviousBid from "./view-previous-bid";
import { useViewBids } from "../../../hooks/react-query/properties/useViewBids";
import SearchBarWithOption from "../../common/searchbar-with-option";
import { useDebounce } from "primereact/hooks";
import { useUploadUrl } from "../../../hooks/react-query/properties/useUploadUrl";
import { useRpaUploadUrl } from "../../../hooks/react-query/properties/useRpaUploadUrl";
import { commonStringMessage } from "../../../utils/messages";
import DropdownC from "../../common/dropdown";
import {
  InvestorBidConversion,
  InvestorBidSubmitted
} from "../../../utils/inv-exch-amplitude";
import { InputText } from "primereact/inputtext";
// import { useBuyerVesting } from "../../../hooks/react-query/properties/useBuyerVesting";
import axios from "axios";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
// import SearchBarWithOptionEntity from "../../common/searchbar-with-option-entity";

const PurchaseOption = [
  { name: "Cash", value: "cash" },
  { name: "Hard Money", value: "hard money" }
];

const QuationOption = [
  { name: "Yes", value: "yes" },
  { name: "No", value: "no" }
];

const PlaceOffer = ({
  sifd,
  propertyId,
  isMobile = window.innerWidth <= 768,
  bidCount,
  disabled
}: any) => {
  const searchParams: any = new URLSearchParams(window.location.search);
  const [investor, debouncedInvestor, setInvestor] = useDebounce<any>("", 500);
  // const [buyerVesting, debouncedBuyerVesting, setBuyerVesting] =
  //   useDebounce<any>("", 500);
  const [buyerVesting, setBuyerVesting] = useState<any>("");
  const [investorObj, setInvestorObj] = useState<any>(null);
  // const [buyerVestingObj, setBuyerVestingObj] = useState<any>(null);
  const [amount, setAmount] = useState<any>(null);
  const [purchaseType, setPurchaseType] = useState<any>(null);
  const [hasReferralFee, setHasReferralFee] = useState<any>(null);
  const [referralFee, setReferralFee] = useState<any>(null);
  const [buyerBeenInside, setBuyerBeenInside] = useState<any>(null);
  const [buysInName, setBuysInName] = useState<any>(null);
  const [lender, setLender] = useState<any>("");
  const [viewBids, setViewBids] = useState(false);
  const [viewBidsMobile, setViewBidsMobile] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [pofFile, setPofFile] = useState<File | null>(null);
  const [rpaFile, setRpaFile] = useState<File | null>(null);
  const [hasSetInitialValues, setHasSetInitialValues] = useState(false);
  const { data: investorData, isFetching: isInvestorFetching } =
    useInvestorList(debouncedInvestor, propertyId, searchParams.get("acctId"));

  // const { data: buyerVestingData, isFetching: isBuyerVestingFetching } =
  //   useBuyerVesting(debouncedBuyerVesting);

  // Set initial values from first contact in data only once
  useEffect(() => {
    if (
      !!searchParams.get("acctId") &&
      investorData?.contacts?.length > 0 &&
      !hasSetInitialValues
    ) {
      const firstContact = investorData.contacts[0];
      setInvestor(firstContact.fullName || "");
      setInvestorObj(firstContact);
      setHasSetInitialValues(true);
    }
  }, [investorData, hasSetInitialValues]);

  useEffect(() => {
    setPofFile(null);
    setRpaFile(null);
  }, [investorObj?.id]);

  const axiosAuth = useAxios();
  const { t } = useTranslation();
  const pofUploadUrlApi = t("upload-url-api");
  const rpaUploadUrlApi = t("rpa-upload-url-api");

  const { showInfo, showSuccess, showError }: any = useToast();
  const {
    data: uploadUrl,
    isPending: isPendingUploadUrl,
    isFetching: isFetchingUploadUrl,
  } = useUploadUrl(investorObj);
  const {
    data: rpaUploadUrl,
    isPending: isPendingRpaUploadUrl,
    isFetching: isFetchingRpaUploadUrl,
  } = useRpaUploadUrl(investorObj);

  // Only block upload UI on the initial load, not background refetches
  const isLoadingUploadUrls =
    (!!investorObj?.uploadPOF && isPendingUploadUrl) ||
    (!!investorObj?.id && isPendingRpaUploadUrl);

  const placeBidMutation = usePlaceBid(
    (data: any) => {
      setPofFile(null);
      setRpaFile(null);
      setAmount(null);
      setPurchaseType(null);
      setReferralFee(null);
      setBuysInName(null);
      setBuyerBeenInside(null);
      showSuccess("info", "Bid Placed Successfully");
      setInvestor("");
      setLender("");
      setBuyerVesting("");
      setHasReferralFee(null);
      setInvestorObj(null);
      // setBuyerVestingObj(null);
    },
    (_error: any) => {
      console.log(_error);
      if (_error?.status === 401) {
        console.log("Please login again");
        // showError("Error", "Please login again");
      } else if (_error?.status === 500) {
        showError("Error", "Something went wrong");
      }
    }
  );
  const pofInputRef: any = React.useRef(null);
  const rpaInputRef: any = React.useRef(null);

  const { data: bids } = useViewBids({ id: propertyId });

  const buildBidPayload = (fileNames?: {
    pofFileName?: string | null;
    rpaFileName?: string | null;
  }) => ({
    propertyId: propertyId,
    amount: `${amount}` || "0",
    contactId: investorObj?.id,
    pofFileName:
      fileNames?.pofFileName !== undefined
        ? fileNames.pofFileName
        : investorObj?.uploadPOF && pofFile
          ? uploadUrl?.fileName || null
          : null,
    rpaFileName:
      fileNames?.rpaFileName !== undefined
        ? fileNames.rpaFileName
        : rpaFile
          ? rpaUploadUrl?.fileName || null
          : null,
    purchaseType: purchaseType,
    buyerBeenInside: buyerBeenInside,
    buysInName: buysInName || "no",
    lender: lender,
    ...(buyerVesting?.length > 0 && { buyerVesting: buyerVesting }),
    ...(hasReferralFee === "yes" && {
      referralFee: `${referralFee}` || "0"
    })
  });

  const buildAnalyticsBidDetails = (fileNames?: {
    pofFileName?: string | null;
    rpaFileName?: string | null;
  }) => ({
    amount: `${amount}` || "0",
    contactId: investorObj?.id,
    pofFileName:
      fileNames?.pofFileName !== undefined
        ? fileNames.pofFileName
        : investorObj?.uploadPOF && pofFile
          ? uploadUrl?.fileName || null
          : null,
    rpaFileName:
      fileNames?.rpaFileName !== undefined
        ? fileNames.rpaFileName
        : rpaFile
          ? rpaUploadUrl?.fileName || null
          : null,
    purchaseType: purchaseType,
    buyerBeenInside: buyerBeenInside,
    buysInName: buysInName || "no",
    lender: lender,
    buyerVesting: buyerVesting,
    ...(hasReferralFee === "yes" && {
      referralFee: `${referralFee}` || "0"
    })
  });

  const validatePdfFile = (file: File) => {
    const maxFileSize = 30 * 1024 * 1024;
    const allowedFileType = "application/pdf";

    if (file.type !== allowedFileType) {
      showInfo("info", commonStringMessage.UploadDocTypeValidation);
      return false;
    }
    if (file.size > maxFileSize) {
      showInfo("info", commonStringMessage.UploadDocSizeValidation);
      return false;
    }
    return true;
  };

  async function handlePofFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (!file || !validatePdfFile(file)) {
      return;
    }
    setPofFile(file);
  }

  async function handleRpaFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (!file || !validatePdfFile(file)) {
      return;
    }
    setRpaFile(file);
  }

  async function uploadFileToS3(preSignedUrl: string, file: File) {
    await axios.put(preSignedUrl, file, {
      headers: {
        "Content-Type": file.type
      }
    });
  }

  async function fetchUploadUrl(apiPath: string, contactId: string) {
    const res = await axiosAuth.get(`${apiPath}/${contactId}`);
    return res?.data?.data as
      | { preSignedUrl?: string; fileName?: string }
      | undefined;
  }

  async function placeBid(retryCount = 1) {
    let resolvedPofFileName: string | null = null;
    let resolvedRpaFileName: string | null = null;

    try {
      setLoadingFile(true);

      if (!investorObj?.id) {
        showInfo("info", commonStringMessage.investorValidation);
        return;
      }

      // Always fetch fresh presigned URLs at submit time so POF + RPA
      // uploads don't race with stale/refetched react-query cache
      if (investorObj?.uploadPOF && pofFile) {
        const pofUrl = await fetchUploadUrl(pofUploadUrlApi, investorObj.id);
        if (!pofUrl?.preSignedUrl || !pofUrl?.fileName) {
          showError("Error", "Unable to get POF upload URL. Please try again.");
          return;
        }
        await uploadFileToS3(pofUrl.preSignedUrl, pofFile);
        resolvedPofFileName = pofUrl.fileName;
      }

      if (rpaFile) {
        const rpaUrl = await fetchUploadUrl(rpaUploadUrlApi, investorObj.id);
        if (!rpaUrl?.preSignedUrl || !rpaUrl?.fileName) {
          showError("Error", "Unable to get RPA upload URL. Please try again.");
          return;
        }
        await uploadFileToS3(rpaUrl.preSignedUrl, rpaFile);
        resolvedRpaFileName = rpaUrl.fileName;
      }

      const fileNames = {
        pofFileName: resolvedPofFileName,
        rpaFileName: resolvedRpaFileName,
      };

      if (!!searchParams.get("acctId")) {
        InvestorBidConversion({
          bid_status: "Bid Placed successfully",
          investor_sfid: investorObj?.SFID,
          property_sfid: sifd ?? "",
          property_id: propertyId ?? "",
          investor_id: investorObj?.id,
          bid_details: buildAnalyticsBidDetails(fileNames)
        });
      }

      await placeBidMutation.mutateAsync(buildBidPayload(fileNames));
    } catch (error: any) {
      setLoadingFile(false);
      if (!!searchParams.get("acctId")) {
        InvestorBidConversion({
          bid_status: "Bid Placed failed",
          investor_sfid: investorObj?.SFID,
          property_sfid: sifd ?? "",
          property_id: propertyId ?? "",
          investor_id: investorObj?.id,
          bid_details: buildAnalyticsBidDetails({
            pofFileName: resolvedPofFileName,
            rpaFileName: resolvedRpaFileName,
          })
        });
      }
      if (error.response?.status === 403 && retryCount > 0) {
        console.log(`Retrying... Attempts left: ${retryCount}`);
        await placeBid(retryCount - 1);
      } else {
        console.error("Place bid failed:", error);
        showError("Error", "Failed to upload documents or place bid. Please try again.");
      }
    } finally {
      setLoadingFile(false);
    }
  }

  const handleSubmitBid = () => {
    if (!investor) {
      showInfo("info", commonStringMessage.investorValidation);
    } else if (amount <= 0) {
      showInfo("info", commonStringMessage.AmountValidation);
    } else if (purchaseType === null || purchaseType?.length <= 0) {
      showInfo("info", commonStringMessage.PurchaseTypeValidation);
    } else if (buyerBeenInside === null || buyerBeenInside?.length <= 0) {
      showInfo("info", commonStringMessage.BuyerBeenInsideValidation);
    } else if (hasReferralFee === "yes" && referralFee <= 0) {
      showInfo("info", commonStringMessage.ReferralFeeValidation);
    } else if (buysInName === null || buysInName?.length <= 0) {
      showInfo("info", commonStringMessage.BuysInNameValidation);
    } else if (lender?.length <= 0) {
      showInfo("info", commonStringMessage.LenderValidation);
    } else if (investorObj?.uploadPOF && !pofFile) {
      showInfo("info", commonStringMessage.PofValidation);
    } else if (!rpaFile) {
      showInfo("info", commonStringMessage.RpaValidation);
    } else if (isLoadingUploadUrls || isFetchingUploadUrl || isFetchingRpaUploadUrl) {
      showInfo("info", "Upload links are still loading. Please wait a moment and try again.");
    }
    // else if (buyerVesting?.length <= 0) {
    //   showInfo("info", commonStringMessage.BuyerVestingValidation);
    // }
    else {
      placeBid();
      InvestorBidSubmitted({
        investor_sfid: investorObj?.SFID,
        property_sfid: sifd ?? "",
        property_id: propertyId ?? "",
        investor_id: investorObj?.id,
        bid_details: buildAnalyticsBidDetails()
      });
    }
  };

  return (
    <>
      <Sidebar
        visible={viewBidsMobile}
        position="bottom"
        onHide={() => setViewBidsMobile(false)}
        className={styles.mobilePreviousBidOffer}
        header={
          <div className={styles.bidWrapHeading}>
            <div className={styles.PreviousHeading}>Previous Bids</div>
            <img
              src="/images/close-bid.svg"
              alt=""
              onClick={() => setViewBidsMobile(false)}
            />
          </div>
        }
      >
        <ViewPreviousBid data={bids} setVisible={setViewBidsMobile} />
      </Sidebar>
      {/* <p>{JSON.stringify(data)}</p> */}
      {viewBids ? (
        <div className={styles.placeOffer}>
          <ViewPreviousBid data={bids} setVisible={setViewBids} />
        </div>
      ) : (
        <div className={styles.placeOffer}>
          {disabled && (
            <div className={styles.Note}>
              Biding time period is closed on this property.
            </div>
          )}
          {!isMobile && (
            <div className={`${styles.title} ${disabled && styles.disabled}`}>
              Place Bid
            </div>
          )}
          <>
            <SearchBarWithOption
              disabled={disabled}
              data={investorData?.contacts}
              showContactOwner={investorData?.showContactOwner}
              placeholder="Search an investor"
              value={investor}
              setValue={setInvestor}
              isLoading={isInvestorFetching}
              investorObj={investorObj}
              setInvestorObj={setInvestorObj}
              className={styles.searchBar}
            />
            <NumberInput
              disabled={disabled}
              type="text"
              onChange={(e: any) => setAmount(e.value)}
              placeholder="Enter Amount"
              value={amount}
              name="amount"
              className={styles.amountInput}
              size="small"
            />
            <DropdownC
              placeholder="Purchase Type"
              showClear={false}
              className={styles.dropdownBox}
              panelClassName={styles.dropdownList}
              options={PurchaseOption}
              optionLabel="name"
              disabled={disabled}
              name="Purchase Type"
              onChange={(e: any) => {
                setPurchaseType(e?.value);
              }}
              value={purchaseType}
            />
            <DropdownC
              placeholder="Has the Buyer been Inside the property?"
              disabled={disabled}
              showClear={false}
              className={styles.dropdownBox}
              panelClassName={styles.dropdownList}
              options={QuationOption}
              optionLabel="name"
              name="Purchase Type"
              onChange={(e: any) => {
                setBuyerBeenInside(e?.value);
              }}
              value={buyerBeenInside}
            />
            <DropdownC
              placeholder="Has referral fee?"
              disabled={disabled}
              showClear={false}
              className={styles.dropdownBox}
              panelClassName={styles.dropdownList}
              options={QuationOption}
              optionLabel="name"
              name="Has Referral Fee"
              onChange={(e: any) => {
                setHasReferralFee(e?.value);
              }}
              value={hasReferralFee}
              index={0}
            />
            {hasReferralFee === "yes" && (
              <NumberInput
                disabled={disabled}
                type="text"
                onChange={(e: any) => setReferralFee(e.value)}
                placeholder="Referral Fee"
                value={referralFee}
                name="Referral Fee"
                className={styles.amountInput}
              />
            )}
            <DropdownC
              placeholder="Buys in Name (No Entity)"
              disabled={disabled}
              showClear={false}
              className={styles.dropdownBox}
              panelClassName={styles.dropdownList}
              options={QuationOption}
              optionLabel="name"
              name="Buys in Name"
              onChange={(e: any) => {
                setBuysInName(e?.value);
              }}
              value={buysInName}
              index={0}
            />
            <InputText
              className={styles.inputBox}
              placeholder="lender"
              disabled={disabled}
              name="lender"
              type="text"
              size="large"
              value={lender}
              onChange={(e: any) => setLender(e.target.value)}
            />
            <InputText
              className={`${styles.inputBox} ${styles.buyerVesting}`}
              placeholder="Buyer Vesting"
              name="buyerVesting"
              type="text"
              disabled={disabled}
              size="large"
              value={buyerVesting}
              onChange={(e: any) => setBuyerVesting(e.target.value)}
            />
            {/* <SearchBarWithOptionEntity
              disabled={disabled}
              data={buyerVestingData}
              showContactOwner={false}
              placeholder="Search Buyer Vesting"
              value={buyerVesting}
              setValue={setBuyerVesting}
              isLoading={isBuyerVestingFetching}
              investorObj={buyerVestingObj}
              setInvestorObj={setBuyerVestingObj}
              className={`${styles.searchBar} ${styles.Buyer}`}
            /> */}
            {investorObj && !isLoadingUploadUrls && (
                <div className={styles.offerSubmissionSection}>
                  <div className={styles.offerSubmissionHeading}>
                    {investorObj?.offerSubmission || "Offer Submission"}
                  </div>
                  {investorObj?.uploadPOF ? (
                    <div className={styles.uploadBox}>
                      <div
                        className={styles.upload}
                        onClick={() => pofInputRef.current?.click()}
                      >
                        <span
                          className={`${styles.text} ${
                            pofFile?.name ? styles.textActive : ""
                          }`}
                        >
                          {pofFile?.name ? pofFile.name : "Upload POF"}
                        </span>
                        <img src="/images/upload.svg" alt="" />
                      </div>
                      <input
                        type="file"
                        ref={pofInputRef}
                        accept="application/pdf"
                        hidden
                        onChange={handlePofFileChange}
                      />
                    </div>
                  ) : (
                    <div className={styles.POFMessage}>POF is Current</div>
                  )}
                  <div className={styles.uploadBox}>
                    <div
                      className={styles.upload}
                      onClick={() => rpaInputRef.current?.click()}
                    >
                      <span
                        className={`${styles.text} ${
                          rpaFile?.name ? styles.textActive : ""
                        }`}
                      >
                        {rpaFile?.name ? rpaFile.name : "Upload Signed RPA"}
                      </span>
                      <img src="/images/upload.svg" alt="" />
                    </div>
                    <input
                      type="file"
                      ref={rpaInputRef}
                      accept="application/pdf"
                      hidden
                      onChange={handleRpaFileChange}
                    />
                  </div>
                </div>
              )}
          </>
          <div
            className={`${isMobile ? styles.btnWrap1 : ""} ${styles.btnWrap}`}
          >
            <Buttonc
              disabled={disabled}
              type="button"
              label="Place Bid"
              size="medium"
              onClick={handleSubmitBid}
              loading={placeBidMutation.isPending || loadingFile}
            />
            {bidCount > 0 ? (
              <Buttonc
                disabled={disabled}
                type="button"
                label={`View Previous Bids (${bidCount})`}
                className={styles.viewBids}
                btnType="link"
                onClick={() => {
                  !isMobile
                    ? setViewBids(!viewBids)
                    : setViewBidsMobile(!viewBidsMobile);
                }}
              />
            ) : (
              <Buttonc
                disabled={disabled}
                className={styles.viewBids}
                type="button"
                label={`You do not have any previous bids`}
                btnType="link"
                // onClick={() => setViewOffer(!viewOffer)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(PlaceOffer);
